export default {
  'forgetpassword.forgetpassword': 'Forgot Password?',
  'forgetpassword.wrongemail': 'Email was not valid',
  'forgetpassword.resetemail':
    'Enter the email address you used when you joined and we’ll send you instructions to reset your password.',
  'forgetpassword.description':
    'For security reasons, we do NOT store your password. So rest assured that we will never send your password via email.',
  'forgetpassword.resetpassword': 'Reset Password',
};
